import { render, staticRenderFns } from "./creerPanneau.vue?vue&type=template&id=06169c7e"
import script from "./creerPanneau.vue?vue&type=script&lang=js"
export * from "./creerPanneau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports